"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PROMO_BANNER = void 0;
const PROMO_BANNER = exports.PROMO_BANNER = 'promo-banner';
